export interface IExternalDemographicAPI {
  externaldemographic_id: number;
  name: string;
  dataprovider_id: number;
}

export default class ExternalDemographic {
  id: number;

  name: string;

  dataProviderID: number;

  children: ExternalDemographic[];

  nameWithParent: string;

  constructor(
    id: number,
    name: string,
    dataProviderID: number,
    children: ExternalDemographic[] = [],
    nameWithParent: string,
  ) {
    this.id = id;
    this.name = name;
    this.dataProviderID = dataProviderID;
    this.children = children;
    this.nameWithParent = nameWithParent;
  }

  get childrenWithParentName(): ExternalDemographic[] {
    return this.children.map((x) => {
      const clone = new ExternalDemographic(
        x.id,
        x.name,
        x.dataProviderID,
        x.childrenWithParentName,
        `${this.name} > ${x.name}`,
      );
      return clone;
    });
  }

  static fromApi(apiObject: IExternalDemographicAPI): ExternalDemographic {
    return new ExternalDemographic(
      apiObject.externaldemographic_id,
      apiObject.name,
      apiObject.dataprovider_id,
      apiObject.children !== undefined && apiObject.children !== null
        ? apiObject.children.map((x: any) => ExternalDemographic.fromApi(x))
        : [],
      '',
    );
  }

  toApi(): IExternalDemographicAPI {
    return {
      externaldemographic_id: this.id >= 0 ? this.id : undefined,
      name: this.name,
      dataprovider_id: this.dataProviderID,
    };
  }
}
